<template>
    <div v-if="$common.isClient_whole()">
<!--        <van-tabbar v-model="select" active-color="red">-->
<!--            <van-tabbar-item icon="home-o" @click="$goto('home_s')">首页</van-tabbar-item>-->
<!--            <van-tabbar-item icon="gift-o" @click="$goto('select')">更多推荐</van-tabbar-item>-->
<!--        </van-tabbar>-->
        <van-tabbar v-model="select" active-color="red">
            <van-tabbar-item icon="home-o" @click="$goto('select')">首页</van-tabbar-item>
            <van-tabbar-item icon="gift-o" @click="$goto('search_page')">搜券</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    export default {
        name: "Wp_tabbar_for_client",
        data(){
            return{
                select : 0
            }
        },

        created() {
            let keyword_encode = this.$common.getUrlKey('keyword');
            if(keyword_encode){
                this.select = 1;
            }
        }
    }
</script>

<style scoped>

</style>